import type { SVGProps } from 'react';

import * as styles from './LegacyStarIcon.css';

export const LegacyStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    className={styles.starIcon}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 15"
    // xml:space="preserve"
  >
    <path
      d="M3.4,13.9c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.2s0-0.2,0-0.3l1-4.2L0.8,5.8c0,0-0.1-0.1-0.1-0.2
	s0-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2S1.1,5,1.2,5h4.1L7,1.1C7.1,1,7.2,1,7.2,0.9c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1
	C7.8,1,7.9,1,7.9,1.1L9.7,5h4c0.1,0,0.2,0,0.3,0.1s0.1,0.1,0.2,0.2c0,0.1,0.1,0.2,0,0.3c0,0.1-0.1,0.2-0.1,0.2l-3,3.2l0.9,4.3
	c0,0.1,0,0.2,0,0.3s-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1l-3.8-2.2l-3.7,2.2c0,0-0.1,0-0.1,0.1L3.4,13.9
	C3.5,14,3.5,13.9,3.4,13.9z M7.6,10.7L7.6,10.7l3.2,1.8L10,9c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.2L12.6,6H9.4
	C9.3,6,9.2,6,9.2,5.9S9,5.8,9,5.7L7.5,2.5L6.1,5.7C6,5.8,6,5.9,5.9,5.9S5.7,6,5.6,6H2.3l2.6,2.7C5,8.7,5,8.8,5.1,8.9
	c0,0.1,0,0.2,0,0.2l-0.8,3.4l3-1.8h0.1h0.1H7.6z"
    />
  </svg>
);
